import React from 'react';
import EntityModal from '../common/EntityModal';
import TaskForm from './TaskForm';

const TaskModal = ({ isOpen, onClose, task = null, onSubmit, loading = false }) => (
  <EntityModal
    isOpen={isOpen}
    onClose={onClose}
    entity={task}
    entityName="Task"
    FormComponent={TaskForm}
    onSubmit={onSubmit}
    loading={loading}
    size="lg"
  />
);

export default TaskModal;
